import {postRequest} from './request';

export const sendFeedbackApi = async (feedback: string) => {
  return await postRequest(`email/feedback`, {text: feedback});
};


